import React, { useState } from 'react';
import { Box, Button, InputAdornment, Link, TextField } from '@mui/material';
import {
  Navigate,
  useParams,
  Link as RouterLink,
  generatePath,
} from 'react-router-dom';
import { useQuery } from '@apollo/client';
import HeaderPage from 'components/HeaderPage';
import { PATH } from '@constants';
import { CaretDown, Search } from 'components/Icons';
import CursoAulasPageAccordion from './CursoAulasPage.Accordion';
import {
  CONTEUDOS_ALUNO_QUERY,
  CursoAulasQuery,
} from './CursoAulasPage.graphql';
import { filterModules } from './CursoAulasPage.filters';

function CursoAulasPage() {
  const { cursoId, materiaId } = useParams<{
    cursoId: string;
    materiaId: string;
  }>();
  if (!cursoId || !materiaId) {
    return <Navigate to={PATH.cursos} />;
  }

  return <InternalCursoAulasPage cursoId={cursoId} materiaId={materiaId} />;
}

function InternalCursoAulasPage({
  cursoId,
  materiaId,
}: {
  cursoId: string;
  materiaId: string;
}) {
  const [search, setSearch] = useState('');

  const { data, refetch: refetchAulas } = useQuery<CursoAulasQuery>(
    CONTEUDOS_ALUNO_QUERY,
    {
      variables: {
        curso: cursoId,
        modulo: materiaId,
      },
      fetchPolicy: 'no-cache',
    }
  );

  return (
    <Box
      display="flex"
      flexDirection="column"
      flex="1 1 auto"
      overflow="hidden"
      height="100%"
    >
      <HeaderPage
        title={data?.materia?.nome}
        endAdornment={
          <Link
            component={RouterLink}
            to={generatePath(PATH.curso, { cursoId })}
            underline="none"
          >
            <Button
              color="text"
              size="large"
              startIcon={<CaretDown sx={{ transform: 'rotate(90deg)' }} />}
            >
              Voltar
            </Button>
          </Link>
        }
      />

      <TextField
        className="search"
        size="small"
        sx={{ mb: 2 }}
        value={search}
        onChange={(event) => setSearch(event.target.value)}
        InputProps={{
          placeholder: 'Buscar por conteúdos',
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
        }}
      />

      <CursoAulasPageAccordion
        modules={filterModules(
          data?.conteudoCategoriaPorModuloAluno || [],
          search
        )}
        {...{ refetchAulas, cursoId, materiaId }}
      />
    </Box>
  );
}

export default CursoAulasPage;
